import React from 'react'

export interface DashboardCardProps {
  title?: string
  /** Right-aligned control or link in the header row. */
  action?: React.ReactNode
  children: React.ReactNode
  className?: string
  /** Off for cards that manage their own padding (tables, charts with bleed). */
  padded?: boolean
}

/**
 * The one card shell both dashboards use.
 *
 * Every card previously carried its own chrome — radii drifted between 16px,
 * 22px and Mantine's 32px, padding between 16px and 32px — so rows never lined
 * up. Everything routes through here instead: same surface, same radius, same
 * padding, and `h-full` so cards sharing a grid row end level.
 */
export const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  action,
  children,
  className = '',
  padded = true,
}) => (
  <div
    className={`bg-white/80 rounded-2xl h-full flex flex-col ${padded ? 'p-6 gap-5' : ''} ${className}`}
  >
    {(title || action) && (
      <div
        className={`flex items-center justify-between gap-3 ${padded ? '' : 'px-4 sm:px-6 pt-6 pb-4'}`}
      >
        {title && (
          <h3 className="text-sm font-semibold text-dashboard-text font-poppins leading-5">
            {title}
          </h3>
        )}
        {action}
      </div>
    )}
    {children}
  </div>
)

export default DashboardCard
